/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Apply file: Found no items in checklist to apply document provided
 * @export
 * @interface PaxCheckNoItemsToApplyDocumentTo
 */
export interface PaxCheckNoItemsToApplyDocumentTo {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckNoItemsToApplyDocumentTo
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckNoItemsToApplyDocumentTo interface.
 */
export function instanceOfPaxCheckNoItemsToApplyDocumentTo(value: object): value is PaxCheckNoItemsToApplyDocumentTo {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckNoItemsToApplyDocumentToFromJSON(json: any): PaxCheckNoItemsToApplyDocumentTo {
    return PaxCheckNoItemsToApplyDocumentToFromJSONTyped(json, false);
}

export function PaxCheckNoItemsToApplyDocumentToFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckNoItemsToApplyDocumentTo {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckNoItemsToApplyDocumentToToJSON(json: any): PaxCheckNoItemsToApplyDocumentTo {
    return PaxCheckNoItemsToApplyDocumentToToJSONTyped(json, false);
}

export function PaxCheckNoItemsToApplyDocumentToToJSONTyped(value?: PaxCheckNoItemsToApplyDocumentTo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

